// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3-QUP","logo":"Footer_logo__xaUWP"};